import { Button, Container, Stack, Typography } from '@mui/material';
import IntroHead from '#/components/shared/IntroHead';
import useLocales from '#/hooks/useLocales';
import TrafficLights from '#/components/pages/PensionProvision/onboarding/steps/profiling/traffic-lights';
import useAuth from '#/hooks/useAuth';
import RedLightRecommendations from '#/components/pages/PensionProvision/onboarding/steps/profiling/recommendations/red-light-recommendations';
import GreenLightRecommendations from './recommendations/green-light-recommendations';
import YellowLightRecommendations from './recommendations/yellow-light-recommendations';
import StepsIndicators from '../registration/steps-indicator';
import { useNavigate } from 'react-router-dom';

const TRAFFIC_LABELS = [
  'pensionProvision.onboarding.stepThree.redLightLabel',
  'pensionProvision.onboarding.stepThree.yellowLightLabel',
  'pensionProvision.onboarding.stepThree.greenLightLabel',
];

const TRAFFIC_LABELS_DESCRIPTION = [
  'pensionProvision.onboarding.stepThree.redLightLabelDescription',
  'pensionProvision.onboarding.stepThree.yellowLightLabelDescription',
  'pensionProvision.onboarding.stepThree.greenLightLabelDescription',
];

export default function StepThree() {
  const { translate } = useLocales();
  const { user } = useAuth();
  const navigate = useNavigate();

  const getTrafficLightState = () => {
    const provisionCount = user?.provision_check_done?.length ?? 0;
    if (provisionCount === 0) return 0;
    if (provisionCount < 6) return 1;
    return 2;
  };

  const isActive = getTrafficLightState();

  const isRedRecommendation = getTrafficLightState() === 0;
  const isYellowRecommendation = getTrafficLightState() === 1;
  const isGreenRecommendation = getTrafficLightState() === 2;

  return (
    <Container maxWidth="lg" sx={{ marginY: 12 }}>
      <IntroHead
        title={String(translate('pensionProvision.onboarding.stepTwo.title'))}
        description=""
      />
      <StepsIndicators activeStep={3} completedSteps={[1, 2]} />

      <Typography variant="subtitle1" fontWeight="normal" textAlign="center">
        {String(translate('pensionProvision.onboarding.stepThree.stepByStep'))}
      </Typography>
      {/* tesxi@yopmail.com */}
      <Stack direction="row" alignItems="center" justifyContent="center">
        <Typography variant="h4" textAlign="center" sx={{ mr: 2 }}>
          {translate('pensionProvision.onboarding.stepThree.score')}
        </Typography>
        <TrafficLights isActive={isActive} />
      </Stack>
      <Typography variant="h5">
        {translate(TRAFFIC_LABELS[isActive])}
      </Typography>
      <Typography variant="subtitle1">
        {translate(TRAFFIC_LABELS_DESCRIPTION[isActive])}
      </Typography>
      {isRedRecommendation && <RedLightRecommendations />}
      {isYellowRecommendation && <YellowLightRecommendations />}
      {isGreenRecommendation && <GreenLightRecommendations />}
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        sx={{ mt: 2 }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{ borderRadius: 10 }}
          onClick={() => navigate('/vorsorge/schritt=2')}
        >
          <Typography>{translate('global.back')}</Typography>
        </Button>
      </Stack>
    </Container>
  );
}
